import { createFileRoute } from '@tanstack/react-router'
import { OrgTreeSection } from '../../../features/org-units/org-tree-section'
import { requireSection } from '../../../features/settings/guards'

export const Route = createFileRoute('/_app/settings/organization')({
  staticData: { crumb: 'settingsSection' },
  beforeLoad: ({ context }) => requireSection(context.session, 'organization'),
  component: OrgTreeSection,
})
